import { api } from "./api";
import {
  AmbassadorContext,
  AmbassadorProfile,
  AmbassadorResources,
  AmbassadorHistoryKind,
  AmbassadorApplication,
  AmbassadorApplicationInput,
} from "../types/ambassadors";
const base = "/ambassadors";
export const ambassadors = {
  application: async () =>
    (await api.get<AmbassadorApplication | null>(`${base}/me/application`)).data,
  apply: async (data: AmbassadorApplicationInput) =>
    (await api.post<AmbassadorApplication>(`${base}/me/application`, data)).data,
  context: async () =>
    (await api.get<AmbassadorContext>(`${base}/context`)).data,
  me: async () => (await api.get<AmbassadorProfile>(`${base}/me`)).data,
  history: async (kind: AmbassadorHistoryKind, skip: number) =>
    (await api.get(`${base}/me/history`, { params: { kind, skip, take: 30 } }))
      .data,
  resources: async () =>
    (await api.get<AmbassadorResources>(`${base}/me/resources`)).data,
  update: (data: unknown) => api.patch(`${base}/me`, data),
  consent: (accepted: boolean) => api.post(`${base}/me/consent`, { accepted }),
  withdraw: () => api.post(`${base}/me/withdraw`),
  report: (data: unknown) => api.post(`${base}/me/reports`, data),
  ticket: (data: unknown) => api.post(`${base}/me/tickets`, data),
  reply: (id: string, body: string) =>
    api.post(`${base}/me/tickets/${id}/replies`, { body }),
};
